import { Injectable } from '@angular/core';

import { Action, State, StateContext } from '@ngxs/store';
import { catchError, tap } from 'rxjs';


import { SchooladviezenInitialState, SchooladviezenStateModel } from '@store/models/schooladviezen.model';
import { SchooladviezenActions } from '@store/actions/schooladviezen.actions';
import { ApiClientService } from '@services/api-client.service';

@State<SchooladviezenStateModel>({
  name: 'schooladviezen',
  defaults: SchooladviezenInitialState,
})
@Injectable()
export class SchooladviezenState {
  constructor(private readonly apiDstService: ApiClientService) {
  }

  @Action(SchooladviezenActions.ReadSchooladviezen)
  readSchooladviezen(ctx: StateContext<SchooladviezenStateModel>) {
    const state = ctx.getState();

    /*
    * schooladviezen already in the state, do not load again
    */
    if (state.schooladviezen.length > 0) {
      return;
    }

    ctx.patchState({ loading: true });

    return this.apiDstService.getSchooladviezen().pipe(
      tap((schooladviezen) => {
        ctx.patchState({ loading: false });
        ctx.patchState({ schooladviezen });
      }),
      catchError((error) => {
        ctx.patchState({ loading: false });
        ctx.patchState({ error });
        return ctx.dispatch(new SchooladviezenActions.ReadSchooladviezenFailure(error));
      }),
    );
  }

}
